import React, {
  createElement,
  RefObject,
  useEffect,
  useRef,
  useState,
} from 'react';
import ReactResizeDetector from 'react-resize-detector';

import CollapseContainer from './styled/CollapseContainer';
import { CollapseProps, CollapseState } from './types';

const Collapse: React.FC<CollapseProps> = props => {
  const [state, setState] = useState<CollapseState>({
    collapsed: true,
    height: null,
  });
  const ref = useRef<HTMLDivElement>() as RefObject<HTMLDivElement>;
  useEffect(() => {
    const { collapsed } = props;
    if (collapsed !== undefined) {
      setState(prevState => ({ ...prevState, collapsed }));
    }
    // Quickfix because of some dummy global animation libraries
    if (props.collapsed === false) {
      const x = window.scrollX;
      const y = window.scrollY;
      window.onscroll = () => {
        window.scrollTo(x, y);
      };
      setTimeout(() => {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        window.onscroll = () => {};
      }, 500);
    }
  }, [props.collapsed]);

  const getContainerHeight = (): number | undefined => {
    return ref.current?.clientHeight;
  };

  const handleResize = (_width: number, height: number): void => {
    setState(prevState => ({ ...prevState, height }));
  };

  const toggleCollapse = (): void => {
    setState(prevState => ({ ...prevState, collapsed: !prevState.collapsed }));
  };

  const renderToggle = (): React.ReactNode | boolean =>
    props.toggleComponent &&
    createElement(props.toggleComponent, {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      collapsed: state.collapsed,
      onClick: toggleCollapse,
    });

  let height = state.collapsed === true ? 0 : state.height;
  if (height === null || height === undefined) {
    height = getContainerHeight();
  }

  return (
    <>
      {props.toggleComponentOnTop && renderToggle()}
      <CollapseContainer height={height ?? 0}>
        <div ref={ref}>
          {props.children}
          <ReactResizeDetector
            handleHeight
            skipOnMount
            onResize={handleResize}
          />
        </div>
      </CollapseContainer>
      {!props.toggleComponentOnTop && renderToggle()}
    </>
  );
};

export { default as CollapseArrow } from './CollapseArrow';

export default Collapse;
